import React, { useEffect } from "react";
import { ComponentProps } from "react";
import { Navigate } from "react-router-dom";

import TelemetryClient from "../../Telemetry/compositions/TelemetryClient";

const NavigateWithTelemetry: React.FC<ComponentProps<typeof Navigate>> = ({ to, ...rest }) => {
  useEffect(() => TelemetryClient.traceNavigation(() => null, to), []);
  return <Navigate to={to} {...rest} />;
};

export default NavigateWithTelemetry;
